import clipboard from "clipboard";
import { Message, Loading } from "element-ui";
import SparkMD5 from 'spark-md5'

/*
去除字符中的逗号
 */
export const removeComma = (str) => {
  let list = str.split(",");
  let result = ``;
  list.forEach((item) => {
    let value = item + " ";
    result = result + value;
  });
  // console.log("============", result);

  return result;
};

// 格式化富文本
export const formatRichtextImg = (text) => {
  return text.replace(
    /\<img/gi,
    '<img style="max-width:100% !important;object-fit:cover;height:auto"  '
  );
};

export const showMsg = (data) => {
  Message.closeAll();
  Message({
    showClose: true,
    ...data,
  });
};

// 复制剪切板
export const clipboardText = (el, msg) => {
  let clip = new clipboard(el, {
    text: function() {
      return msg;
    },
  });
  clip.on("success", function() {
    //
    showMsg({
      type: "success",
      message: "复制成功",
    });
    clip.destroy();
  });
  clip.on("error", function(err) {
    //
    console.error(err);
    showMsg({
      type: "error",
      message: "复制失败",
    });
    clip.destroy();
  });
};

export function showErrMsg(msg) {
  console.log("msg", msg);
}


/**
 * 获取系统类型
 * @returns
 */
export function getOsInfo() {
  let ua = window.navigator.userAgent;
  if (/iphone/gi.test(ua) && /mac/gi.test(ua)) {
    return "ios";
  } else if (/mac/gi.test(ua)) {
    return `mac`;
  } else if (/android/gi.test(ua)) {
    return "android";
  } else if (/windows/gi.test(ua)) {
    return "windows";
  }
}

/**
 * 获取浏览器名称
 * @returns
 */
export function getBrowser() {
  let ua = window.navigator.userAgent;
  function check360() {
    var result = false;
    for (var key in navigator.plugins) {
      // np-mswmp.dll只在360浏览器下存在
      if (navigator.plugins[key].filename == "internal-nacl-plugin") {
        return !result;
      }
    }
    return result;
  }
  if (/qqbrowser/gi.test(ua)) {
    return `QQBrowser`;
  } else if (/Wechat/gi.test(ua)) {
    return `wechatBrowser`;
  } else if (/edg/gi.test(ua)) {
    return `edge`;
  } else if (/Firefox/gi.test(ua)) {
    return `Firefox`;
  } else if (/SE 2.X/gi.test(ua)) {
    return "sougou";
  } else if (check360()) {
    return "360Browser";
  } else if (/chrome/gi.test(ua) && /safari/gi.test(ua)) {
    return "chrome";
  }
}


/**
 * 是否是移动端
 * @returns
 */
export function hasMobileDevice() {
  var uA = navigator.userAgent.toLowerCase();
  var ipad = uA.match(/ipad/i) == "ipad";
  var iphone = uA.match(/iphone os/i) == "iphone os";
  var midp = uA.match(/midp/i) == "midp";
  var uc7 = uA.match(/rv:1.2.3.4/i) == "rv:1.2.3.4";
  var uc = uA.match(/ucweb/i) == "ucweb";
  var android = uA.match(/android/i) == "android";
  var windowsce = uA.match(/windows ce/i) == "windows ce";
  var windowsmd = uA.match(/windows mobile/i) == "windows mobile";
  if (
    !(ipad || iphone || midp || uc7 || uc || android || windowsce || windowsmd)
  ) {
    // PC 端
    return false;
  } else {
    // 移动端
    return true;
  }
}

export function createMD5(file, chunkSize = 1024 * 1024 * 2) {
  return new Promise((resolve, reject) => {
    let blobSlice =
        File.prototype.slice ||
        File.prototype.mozSlice ||
        File.prototype.webkitSlice,
      // chunkSize = 1024 * 1024 * 2, // Read in chunks of 2MB
      chunks = Math.ceil(file.size / chunkSize),
      currentChunk = 0,
      spark = new SparkMD5.ArrayBuffer(),
      fileReader = new FileReader();
    fileReader.onload = e => {
      spark.append(e.target.result);
      currentChunk++;
      if (currentChunk < chunks) {
        loadNext();
      } else {
        //
        resolve(spark.end());
      }
    };
    fileReader.onerror = err => {
      console.error("读取失败");
      reject();
    };

    function loadNext() {
      let start = currentChunk * chunkSize,
        end = start + chunkSize >= file.size ? file.size : start + chunkSize;

      fileReader.readAsArrayBuffer(blobSlice.call(file, start, end));
    }
    loadNext();
  });
}


// WEBPACK FOOTER //
// ./src/utils/tool.js